import React, { useState } from 'react';
import { StatOptions } from 'fs';
import { PaymentModel, RiderModel, ActionType, RiderStatusType, User, RiderPackageModel, BranchModel, CustomerAddressModel, VehicleDataModel, ManufacturerModel, VehicleModelModel, Riders_PackagesModel, CustomerContactDetailsModel, RiderPackage } from '../../models/superbit-api-models'
import { SubscribersModel } from '../../models/SubscribersModel'
import '../../assets/css/_new-subscriber-popup.css'

import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../../models/Site'
import { SimulatorModel, SimulatorData } from '../../models/SimulatorModel'
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import {DynamicSelect} from '../../components/_DynamicSelect'
// import 'react-dropdown-tree-select/dist/styles.css';
// import { Autocomplete } from '../../components/_Autocomplete';
import Payment from '../../Payments/_Payment'
import PaymentsList from '../../Payments/_PaymentsList'
import MessegePopup from './_MessegePopup';


type Props = {
    id: string | undefined;
    actionType: ActionType | undefined;
    ClosePopup: any;

    rider?: RiderModel | undefined | null;
    setPopupShow: React.Dispatch<React.SetStateAction<boolean>>
    setMessege: React.Dispatch<React.SetStateAction<string>>
    setMessageType: React.Dispatch<React.SetStateAction<string>>

};
type State = {
    data: RiderModel | null;
    Gender: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    AuthorizedToDriveItems: IDNameDescriptionDictionary;
    InsuranceTypes: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    CustomerAgents: IDNameDescriptionDictionary;
    StationUserId: string;
    AgentId: string;
    CustomerHandlers: IDNameDescriptionDictionary;
    SubscriptionStatuses: IDNameDescriptionDictionary;
    Branches: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    SelectedTab: number;
    RiderStatusType: Array<RiderStatusType>;
    licenseNumber: string;
    editMode: boolean;
    packagesList: IDNameDescriptionDictionary;
    Branches2: IDNameDescriptionDictionary;
    allCities: any[];
    streetList: [];
    citiesAutocomplete: Array<AutocompleteData>
    streetAutocomplete: Array<AutocompleteData>
    payment: PaymentModel | undefined;
    currentPayment: PaymentModel | undefined;
    paymentId: string | undefined;
    SaveEventHandle: string;
    isAddPayment: boolean;
    popupShow: boolean;
    position: any;
    isDragging: boolean;
    offset: any;
    saveLoading: boolean;
    paymentsList: PaymentModel[] | undefined;

};
// AuthorizedToDriveItems


export class SubscriberUpdatePaymentPopup extends React.Component<Props> {

    private birthDateRef: React.RefObject<DatePicker>;
    private subscriptionStartDateRef: React.RefObject<DatePicker>;
    private subscriptionEndDateRef: React.RefObject<DatePicker>;
    simulatorModel: SimulatorModel;

    state: State = {
        data: null,
        Gender: new IDNameDescriptionDictionary(),
        IdentityTypes: new IDNameDescriptionDictionary(),
        VehicleOwnership: new IDNameDescriptionDictionary(),
        AuthorizedToDriveItems: new IDNameDescriptionDictionary(),
        InsuranceTypes: new IDNameDescriptionDictionary(),
        MaritalStatus: new IDNameDescriptionDictionary(),
        CustomerAgents: new IDNameDescriptionDictionary(),
        CustomerHandlers: new IDNameDescriptionDictionary(),
        SubscriptionStatuses: new IDNameDescriptionDictionary(),
        Branches: new IDNameDescriptionDictionary(),
        CarYear: [],
        SelectedTab: 3,
        RiderStatusType: [],
        licenseNumber: '',
        editMode: false,
        packagesList: new IDNameDescriptionDictionary(),
        Branches2: new IDNameDescriptionDictionary(),
        StationUserId: '',
        AgentId: '',
        allCities: [],
        streetList: [],
        citiesAutocomplete: [],
        streetAutocomplete: [],
        payment: undefined,
        paymentId: undefined,
        currentPayment: undefined,
        SaveEventHandle: "",
        isAddPayment: false,
        popupShow: false,
        position: { x: 500, y: 30 },
        isDragging: false,
        offset: { x: 0, y: 0 },
        saveLoading: false,
        paymentsList: []
    };

    constructor(props: any) {
        super(props);
        this.birthDateRef = React.createRef<DatePicker>();
        this.subscriptionStartDateRef = React.createRef<DatePicker>();
        this.subscriptionEndDateRef = React.createRef<DatePicker>();
        this.simulatorModel = new SimulatorModel();
    }

    closePopup = () => {
        this.props.ClosePopup();
        console.log('closePopup')
    }

    save = async () => {

        this.setState({ SaveEventHandle: new Date().getTime() + "" ,popupShow: true});

    }

    changeCurrentTab = (num: number) => {
        let currentTab = this.state.SelectedTab;
        currentTab += num;
        this.setState({
            SelectedTab: currentTab
        });
    }

    editPayment = async (id: string) => {
        console.log('id', id)
        await this.setState({ paymentId: id });
    }

    setIsAddPayment = (isAddPayment: boolean) => {
        this.setState({ isAddPayment: isAddPayment });
    }

    componentDidMount() {
        this.load();
    }

    handleChange(e: any) { }

    async load() {
        var currentPayment = undefined;
        //if(this.props.rider && this.props.rider.payments && this.props.rider.payments.length==1){
        if (this.props.rider && this.props.rider.payments && this.props.rider.payments.length > 0) {
            if (this.props.rider.payments.length == 1) {
                currentPayment = this.props.rider.payments[0];
                console.log('currentPayment first', currentPayment)
                this.setState({ paymentId: currentPayment.paymentStatus === 0 ? this.props.rider.payments[0].id : '' });
            }
            else if (this.props.rider.payments.filter(x => x.paymentStatus == 0).length > 0) {
                var p = this.props.rider.payments.filter(x => x.paymentStatus == 0)[0].id;
                currentPayment = this.props.rider.payments.filter(x => x.paymentStatus == 0)[0];
                this.setState({ paymentId: currentPayment.paymentStatus === 0 ? p : '' });
            }
            else {
                const p = this.props.rider.payments.sort((a: PaymentModel, b: PaymentModel) => {
                    const dateA = a.createdDate ? a.createdDate.getTime() : 0;
                    const dateB = b.createdDate ? b.createdDate.getTime() : 0;
                    return dateB - dateA;
                })[0];
                currentPayment = p;
                this.setState({ paymentId: currentPayment.paymentStatus === 0 ? p.id : '' });
            }
        }
        console.log('currentPayment', currentPayment)

        this.setState({ currentPayment: currentPayment, isAddPayment: currentPayment && currentPayment.paymentStatus === 0 ? true : false });
        if (this.props.rider) {

            try {
                
                const response = await new SubscribersModel().riderGetPaymentPage(this.props.rider);
                console.log('response', response)
                if (response.status === 200) {
                    this.setState({ Payment: response });
                }
                else if(response.status === 400){
                    let error = response.errors;
                    let errorMessege = error['Customer.CustomerContactDetails[0].Number'][0];
                    this.props.setPopupShow(true);
                    this.props.setMessege(errorMessege + " בתיק לקוח ");
                    this.props.setMessageType('שגיאה');
                }
            } catch (error) {
                console.log('error riderGetPaymentPage ', error)
                this.props.setPopupShow(true);
                    this.props.setMessege("שגיאה במעבר לתשלום");
                    this.props.setMessageType('שגיאה');
            }
        }




        var CarYear = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYear.push(i + "");
        }
        // const model = this.props.rider ? this.props.rider : new RiderModel();// await new SubscribersModel().upsertRider(this.props.id,this.props.actionType);
        const model = await new SubscribersModel().upsertRider({
            id: this.props.id,
            actionType: this.props.actionType
        });
        console.log('model', model);
        // console.log('rider', this.props.rider);

        let licenseNumber = '';
        if (model.vehicle && model.vehicle.licenseNumber) {
            licenseNumber = model.vehicle.licenseNumber;
        }


        if (this.props.id && this.props.id != '') {
            this.setState({
                editMode: true
            });
        } else {
            model.customer.dateOfBirth = new Date();
        }

        if (model && model.customer && model.customer.customerAddresses && model.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            model.customer.customerAddresses.push(address);
        }
        var payments = this.props.id ? await new SubscribersModel().riderGetPayments(this.props.id, undefined) : [];

        const allCities = await this.simulatorModel.getCitiesAutocomplete()
        this.setState({
            data: model,
            paymentsList:[...payments],
            Gender: await this.simulatorModel.getGenderTypes(),
            IdentityTypes: await this.simulatorModel.getIdentityTypes(),
            VehicleOwnership: await this.simulatorModel.getVehicleOwnership(),
            AuthorizedToDriveItems: await this.simulatorModel.getAuthorizedToDriveItems(),
            InsuranceTypes: await this.simulatorModel.getInsuranceTypes(),
            MaritalStatus: await this.simulatorModel.getMaritalStatus(),
            CarYear: CarYear,
            SelectedTab: 3,
            RiderStatusType: [],
            CustomerHandlers: await this.normalizeHandlers(),
            CustomerAgents: await this.normalizeAgents(),
            Branches: await this.buildTreeSelectData(),
            selectedBranch: null,
            licenseNumber: licenseNumber,
            SubscriptionStatuses: [
                {
                    description: 'פעיל',
                    name: 'פעיל',
                    id: 0
                },
                {
                    description: 'מוקפא',
                    name: 'מוקפא',
                    id: 1
                },
                {
                    description: 'ביטול',
                    name: 'ביטול',
                    id: 1
                }
            ],
            packagesList: this.buildPackagesList(model.packages),
            Branches2: await this.buildBranchesSelectData(),
            allCities: allCities,
            streetList: [],
            citiesAutocomplete: allCities,
            streetAutocomplete: []
        });

        console.log('Edit', this.state)
    }


    async getBranchesTree() {
        const allBranches = await this.simulatorModel.getBranches();
        const branchesTree = allBranches.filter((b: any) => b.parentId === null);
        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = this.getSubBranches(rootBranch, allBranches);
        });

        console.log('branchesTree', branchesTree);

        return branchesTree;
    }

    getSubBranches = (branch: any, branches: any[]) => {
        const subBranches = branches.filter((b: any) => b.parentId === branch.id);
        if (subBranches && subBranches.length > 0) {
            subBranches.forEach((b: any) => {
                b.children = this.getSubBranches(b, branches);
            })
        }
        return subBranches;
    }

    arangeBranchesIntoTree = (bList: any[]) => {
        bList.forEach((branch: any, index: number) => {
            if (branch.parentId !== null) {
                const parentItem = bList.find((i: any) => i && i.id && i.id === branch.parentId);
                if (parentItem) {
                    const child = JSON.parse(JSON.stringify(branch));
                    if (parentItem.children) {
                        parentItem.children.push(child);
                    } else {
                        parentItem.children = [child];
                    }
                }
                delete bList[index];
            }
        })
    }

    getTreeItem = (branch: any, isParent = true) => {
        if (branch.children) {
            isParent = true;
        }
        const item = {
            label: branch.name,
            value: branch.id,
            isParent: isParent ? true : false,
            // disabled: isParent ? true : false,
            className: 'hidden-checkbox',
            children: []
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((c: any) => {
                const newItem = this.getTreeItem(c);
                item.children.push(newItem as never);
            })
        }
        return item;
    }

    onBranchChange = (e: any) => {
        const branches = this.state.Branches as any;
        if (e.checked && !e.isParent) {
            this.setState({
                selectedBranch: e.value
            });
        } else {
            this.setState({
                selectedBranch: null
            });
        }

        branches.forEach((branch: any) => {
            branch.checked = false;
            if (branch.children) {
                branch.children.forEach((child: any) => {
                    if (child.value === e.value && e.checked) {
                        child.checked = true;
                    } else {
                        child.checked = false
                    }
                });
            }
        });

        this.setState({
            Branches: branches
        })
        console.log('onBranchChange', e)
    }

    onBranchToggle = (e: any) => {
        // console.log('onBranchToggle', e);
    }


    buildTreeSelectData = async () => {
        const allBranches = await this.simulatorModel.getBranches();
        const rootItems = allBranches.filter((b: any) => b.parentId === null);
        const subBranches = allBranches.filter((b: any) => b.parentId != null);
        const branchesTree: any = [];
        rootItems.forEach((bItem: any) => {
            const branch = this.buildBranchData(bItem.id, allBranches);
            branchesTree.push(branch);
        });

        // this.setState({
        //     Branches: branchesTree
        // });
        console.log('branchesTree', subBranches, branchesTree);
        return branchesTree;
    }

    buildBranchData = (branchId: string | null, allBranches: any[]) => {
        const branchData = allBranches.find((b: any) => b.id === branchId);
        const branch: any = {
            label: branchData.name,
            value: branchData.id,
            tagClassName: ''
        }
        const subBranches: any[] = [];
        const items = allBranches.filter((b: any) => b.parentId === branchId);
        items.forEach((item: any) => {
            const branchSub = this.buildBranchData(item.id, allBranches);
            subBranches.push(branchSub);
        });
        branch.children = subBranches;
        if (branchData.users && branchData.users.length > 0) {
            branchData.users.forEach((user: any) => {
                branch.children.push({
                    value: user.value,
                    label: user.text
                })
            })
        }
        return branch;
    }

    onTreeSelectChange = (currentNode: any, selectedNodes: any[]) => {
        console.log(currentNode, selectedNodes);
    }

    async normalizeHandlers() {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardHandlers();
        const returnDictionary: any = {}
        customerCardHandlers.map((c: User, key: number) => {
            const item: any = {};
            item.description = c.fullName;
            item.name = c.fullName;
            item.id = c.id;
            returnDictionary[key] = item;
        });
        return returnDictionary;
    }

    async normalizeAgents() {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardAgents();
        const agents: IDNameDescriptionItem[] = [];
        agents.push({
            description: 'סוכן',
            name: '',
            id: 0
        })
        customerCardHandlers.map((a: any) => {
            agents.push({
                description: a.name,
                name: a.name,
                id: a.id
            })
        });

        return agents as IDNameDescriptionItem[];
    }

    buildPackagesList = (packages: any) => {
        const newList: any = [{
            description: 'בחר',
            name: '',
            id: 0,
            package: null
        }];
        packages.forEach((p: any) => {
            newList.push({
                description: p.name,
                name: p.name,
                id: p.id
            })
        });
        console.log('buildPackagesList', newList)
        return newList as IDNameDescriptionDictionary;
    }

    async normalizeBranches() {
        const branchesList = await this.simulatorModel.getBranches();
        // return customerCardHandlers.map((a: any) => {
        //     return {
        //         description: a.name,
        //         name: a.name,
        //         id: a.id
        //     }
        // }) as IDNameDescriptionItem[];
    }

    setStateData = async (name: string, value: any) => {
        let stateData = this.state.data;
        if (!stateData) {
            stateData = new RiderModel();
        }
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            stateData.customer.customerAddresses.push(address);
        }
        if (stateData.customer) {
            if (!stateData.customer.customerContactDetails) {
                stateData.customer.customerContactDetails = [];
            }
            if (stateData.customer.customerContactDetails.length == 0) {
                const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                    id: '00000000-0000-0000-0000-000000000000',
                    emailAddress: '',
                    number: ''
                })
                stateData.customer.customerContactDetails.push(customerContactDetail);
            }
        }
        switch (name) {
            // customer
            case 'identifier': {
                if (this.isValidIsraeliID(value)) {
                    const customerData = await this.simulatorModel.getCustomerDetailsById(value);
                    console.log('customerData', customerData);
                    if (customerData && customerData.customer) {
                        if (stateData && stateData.customer) {
                            stateData.customer.identityType = customerData.customer.identityType;
                            stateData.customer.firstName = customerData.customer.firstName;
                            stateData.customer.lastName = customerData.customer.lastName;

                            const bDate = new Date(customerData.customer.dateOfBirth.replace('T', ' '));
                            stateData.customer.dateOfBirth = bDate;

                            stateData.customer.gender = customerData.customer.gender;

                            stateData.customer.customerContactDetails = customerData.customer.customerContactDetails;
                            stateData.customer.customerAddresses = customerData.customer.customerAddresses;

                        }
                    }
                }
                if (stateData && stateData.customer) {
                    stateData.customer.identifier = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'identityType': {
                if (stateData && stateData.customer) {
                    stateData.customer.identityType = value;
                }
                break;
            }
            case 'firstName': {
                if (stateData && stateData.customer) {
                    stateData.customer.firstName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'lastName': {
                if (stateData && stateData.customer) {
                    stateData.customer.lastName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'dateOfBirth': {
                if (stateData && stateData.customer) {
                    stateData.customer.dateOfBirth = value as Date;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'gender': {
                if (stateData && stateData.customer) {
                    stateData.customer.gender = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'telNumber': {
                if (stateData.customer) {
                    if (!stateData.customer.customerContactDetails) {
                        stateData.customer.customerContactDetails = [];
                    }
                    if (stateData.customer.customerContactDetails.length == 0) {
                        const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                            id: '',
                            emailAddress: '',
                            number: ''
                        })
                        stateData.customer.customerContactDetails.push(customerContactDetail);
                    }
                    stateData.customer.customerContactDetails[0].number = value;
                }

                break;
            }
            case 'emailAddress': {
                if (stateData && stateData.customer && stateData.customer.customerContactDetails && stateData.customer.customerContactDetails.length > 0) {
                    stateData.customer.customerContactDetails[0].emailAddress = value;
                }
                break;
            }
            // customer address
            case 'city': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].city = value;
                }
                break;
            }
            case 'street': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].street = value;
                }
                break;
            }
            case 'houseNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].houseNumber = value;
                }
                break;
            }
            case 'apartmentNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].apartmentNumber = value;
                }
                break;
            }
            case 'postalCode': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].postalCode = value;
                }
                break;
            }
            case 'mailbox': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].mailbox = value;
                }
                break;
            }
            // vehicle
            case 'licenseNumber': {
                if (stateData && stateData.vehicle && stateData.vehicle.licenseNumber) {
                    stateData.vehicle.licenseNumber = value;
                }

                break;
            }
            case 'stationUserId': {
                // if (stateData && stateData.stationUserId) {
                //     stateData.stationUserId = value;
                // }
                this.setState({
                    StationUserId: value
                });
                break;
            }
            case 'agentId': {
                this.setState({
                    AgentId: value
                });
                break;
            }
            default:
                (stateData as any)[name] = value
                break;
        }
        this.setState({ data: stateData });
    }

    onCityChange = (city: string) => {
        let stateData = this.state.data;
        const cities = this.state.allCities.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(city) > -1
            }
        );
        this.setState({
            citiesAutocomplete: cities
        });
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            this.setState({ data: stateData });
            console.log('onCityChange', city, this.state.citiesAutocomplete, stateData.customer.customerAddresses[0].city)
        }
    }

    onCitySelect = (city: string) => {
        console.log('onCitySelect', city)
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            this.setState({ data: stateData });

            const streetAutocomplete = this.simulatorModel.getStreetsAutocomplete(city);
            this.setState({ streetList: streetAutocomplete });
        }
    }

    onStreetChange = (street: string) => {
        const streets = this.state.streetList.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(street) > -1
            }
        );
        this.setState({
            streetAutocomplete: streets
        });
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            this.setState({ data: stateData });
            // console.log('onStreetChange', street, this.state.streetAutocomplete, stateData.customer.customerAddresses[0].street)
        }
    }
    onStreetSelect = (street: string) => {
        console.log('onstreetSelect', street)
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            this.setState({ data: stateData });
        }
    }


    getVehicleDetailsKeyPress = async (event: any) => {
        console.log(event.key);
        if (event.key === 'Enter' || event.key === 'Tab') {
            const licenseNumber = event.currentTarget.value;
            this.getVehicleDetails(licenseNumber);
            this.setStateData('licenseNumber', licenseNumber)
        } else {
            // this.setState({licenseNumber: event.target.value});
        }
    }

    getVehicleDetails = async (licenseNumber: string) => {
        var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);

        console.log('getVehicleDetailsByLicenseNumber', data);
        let riderData = this.state.data;
        if (!riderData) {
            riderData = new RiderModel();
        }
        if (!riderData.vehicle) {
            riderData.vehicle = new VehicleDataModel();
        }

        console.log(riderData.vehicle);


        if (data && data.LeviItzhak != null) {
            if (data.LeviItzhak.manufacturer != null) {
                if (!riderData.vehicle.manufacturer) {
                    riderData.vehicle.manufacturer = new ManufacturerModel();
                }
                riderData.vehicle.manufacturer.name = data.LeviItzhak.manufacturer.label;
                riderData.vehicle.manufacturer.id = data.LeviItzhak.manufacturer.val;

            }
            if (data.LeviItzhak.vehicleModel != null) {
                if (!riderData.vehicle.vehicleModel) {
                    riderData.vehicle.vehicleModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleModel.name = data.LeviItzhak.vehicleModel.label;
                riderData.vehicle.vehicleModel.id = data.LeviItzhak.vehicleModel.val;
            }
            if (data.LeviItzhak.vehicleSubModel != null) {
                if (!riderData.vehicle.vehicleSubModel) {
                    riderData.vehicle.vehicleSubModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                riderData.vehicle.vehicleSubModel.name = data.LeviItzhak.vehicleSubModel.label;
                riderData.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
            }

            riderData.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
            riderData.vehicle.carYear = data.LeviItzhak.carYear;
            riderData.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
        }
        this.setState({
            data: riderData
        })
    }

    onSelectPackage(name: string, value: any) {
        console.log(name, value);
        const riderData = this.state.data;
        if (riderData && riderData.packages) {
            const selectedPackage = riderData.packages.find((p: any) => p.id === value);
            if (selectedPackage) {
                console.log('selectedPackage', selectedPackage);
                this.addRiderPackage(selectedPackage);
            }
        }
    }

    addRiderPackage = (selectedPackage: any) => {
        const data = this.state.data ? this.state.data : new RiderModel();
        if (!data.riderPackages) {
            data.riderPackages = [];
        }

        const newRiderPackage = new Riders_PackagesModel();
        newRiderPackage.riderId = data.id;
        newRiderPackage.riderPackageId = selectedPackage.id;
        newRiderPackage.riderPackage = selectedPackage;
        newRiderPackage.agentCost = selectedPackage.agentCost;
        newRiderPackage.customerCost = selectedPackage.recommendedCost;

        data.riderPackages.push(newRiderPackage);

        this.setState({ data: data });
    }

    removeRiderPackage = (packageId: string) => {
        // 
        console.log('packageId to remove:', packageId);
        const data = this.state.data ? this.state.data : new RiderModel();
        if (data.riderPackages) {
            const selectedPackageIndex = data.riderPackages.findIndex((p: any) => p && p.riderPackageId === packageId);
            if (selectedPackageIndex >= 0) {
                // console.log('package to remove:', selectedPackage);
                delete data.riderPackages[selectedPackageIndex];
                this.setState({
                    data: data
                });
            }
        }
    }


    async buildBranchesSelectData() {
        const branches = await this.getBranchesTree();
        let branchesSelectData: any[] = [];

        branches.forEach((b: any) => {
            const items = this.buildBranchSelectItems(b, '');
            branchesSelectData = Object.assign(branchesSelectData, items);
        });
        const newList = new IDNameDescriptionDictionary();
        const bList = this.buildSelectDataObject(branchesSelectData);
        newList['0'] = {
            description: 'עמדה',
            name: '',
            id: 0
        }
        bList.forEach((b, index) => {
            if (b && b.id) {
                newList[b.id] = b;
            }
        });
        console.log('newList', newList)
        return newList;
    }

    buildBranchSelectItems = (branch: any, branchName: string = '') => {
        const b = {
            label: "VP Accounting",
            tagClassName: "special",
        }
        if (branchName !== '') {
            branchName += '/';
        }
        branchName += branch.name;
        let items: any[] = [];
        if (branch.users && branch.users.length > 0) {
            branch.users.forEach((user: any) => {
                items.push({
                    value: user.value,
                    text: branchName + '/' + user.text
                })
            })
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((child: any) => {
                const childItems = this.buildBranchSelectItems(child, branchName);
                if (childItems && childItems.length > 0) {
                    items = Object.assign(items, childItems);
                }
            })
        }

        return items;
    }

    buildSelectDataObject = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.text,
                name: a.text,
                id: a.value
            }
        }) as IDNameDescriptionItem[];
    }

    isValidIsraeliID = (id: string) => {
        var id = String(id).trim();
        if (id.length > 9 || id.length < 5 || isNaN(parseInt(id))) return false;

        // Pad string with zeros up to 9 digits
        id = id.length < 9 ? ("00000000" + id).slice(-9) : id;

        return Array
            .from(id, Number)
            .reduce((counter, digit, i) => {
                const step = digit * ((i % 2) + 1);
                return counter + (step > 9 ? step - 9 : step);
            }) % 10 === 0;
    }

    isAdmin = (): boolean => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0
        }
        return false;
    }

    handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
            this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
        };
        
    handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.state.isDragging) {
            this.setState({ position: { x: e.clientX - this.state.offset.x, y: e.clientY - this.state.offset.y } });
        }
    };
    
    handleMouseUp = (): void => {
        this.setState({ isDragging: false });
    };

    onClose = () => {
        this.setState({ popupShow: false });
    }

    setSaveLoading = (loading: boolean) => {   
        this.setState({ saveLoading: loading });
    }

    render() {
        // var data = await new SubscribersModel().riderGetPaymentPage2(undefined, props.PaymentId);
        return (<>

            
            {this.state.data != null ? (
                <>
                    <div className="popup-wrapper">
                        <section className="popup-window new-subscriber rtl"
                        style={{ position: 'absolute', top: this.state.position.y, left: this.state.position.x }}
                        >
                            <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div>
                            <div className="popup-content">
                                <div className="popup-header"
                                style={{ cursor: this.state.isDragging ? 'grabbing' : 'grab', }}
                                onMouseDown={this.handleMouseDown}
                                onMouseMove={this.handleMouseMove}
                                onMouseUp={this.handleMouseUp}
                                onMouseLeave={this.handleMouseUp}
                                >
                                    <div className="popup-title">
                                        חיובים ופרטי תשלום
                                    </div>
                                </div>
                                <div className="popup-body">
                                    <div className="tab-contents">
                                        <PaymentsList paymentsList={this.state.paymentsList} RiderId={this.state.data.id} EditPayment={this.editPayment} setIsAddPayment={this.setIsAddPayment} />

                                    </div>



                                    <div className="tab-contents">
                                        {this.state.paymentId ? <Payment 
                                        paymentData={this.state.paymentsList && this.state.paymentsList.length > 0 ? this.state.paymentsList[this.state.paymentsList.length - 1] : {}} 
                                        ClosePopup={this.props.ClosePopup} PaymentId={this.state.paymentId} SaveEventHandle={this.state.SaveEventHandle} Reload={this.editPayment} RiderId={this.state.data.id}
                                        setPopupShow={this.props.setPopupShow} setMessege={this.props.setMessege} isAdmin={this.isAdmin}
                                        setSaveLoading={this.setSaveLoading}></Payment> :

                                            this.state.isAddPayment ? <Payment 
                                            paymentData={this.state.paymentsList && this.state.paymentsList.length > 0 ? this.state.paymentsList[this.state.paymentsList.length - 1] : {}}
                                            ClosePopup={this.props.ClosePopup} PaymentId={""} SaveEventHandle={this.state.SaveEventHandle} Reload={this.editPayment} RiderId={this.state.data.id}
                                            setPopupShow={this.props.setPopupShow} setMessege={this.props.setMessege} isAdmin={this.isAdmin}
                                            setSaveLoading={this.setSaveLoading}></Payment> : ""}

                                    </div>
                                </div>
                                <div className="popup-footer">
                                    <button className="button white blue-border" onClick={(e: any) => this.closePopup()}>
                                        ביטול
                                    </button>
                                    <button className={this.state.currentPayment && this.state.currentPayment.amount && (this.state.currentPayment.amount > 0 || this.isAdmin()) ? "button white blue-border" : "hide"} onClick={(e: any) => this.save()}
                                        disabled={this.state.saveLoading ? true : false}>
                                        שמור
                                        <img src={require("../../assets/images/loading.gif")} className={this.state.saveLoading ? "loadingGif" : "hide"} />

                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                </>
            ) : ""}
        </>



        );
    }
}
